// « Régénérer cet album » on the order page (owner, 2026-10-17 — #1249): the
// server rebuilds ONLY this album's PDFs (and the 3D pages follow), without the
// editor, without « Commander », without any message to the client.
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ordersApi } from '@/lib/api';
import { useT } from '@/lib/i18n';
import QuickBuildProgress from '@/components/QuickBuildProgress';

export function AlbumRegenerateButton({ shopifyOrderId, albumIndex }: { shopifyOrderId: string; albumIndex: number }) {
  const { t } = useT();
  const queryClient = useQueryClient();
  const [state, setState] = useState<'idle' | 'sending' | 'queued' | 'error'>('idle');
  const [at, setAt] = useState(0);
  async function go() {
    setState('sending');
    try {
      await ordersApi.pdfRegenerate(shopifyOrderId, { album: albumIndex });
      setAt(Date.now());
      setState('queued');
      queryClient.invalidateQueries({ queryKey: ['order', shopifyOrderId] });
    } catch {
      setState('error');
    }
  }
  return (
    <span className="inline-flex flex-col gap-1.5">
    <button
      type="button"
      onClick={go}
      disabled={state === 'sending' || state === 'queued'}
      title={t('Le serveur reconstruit les PDF et l’aperçu 3D de cet album seulement. Rien n’est envoyé au client.')}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-medium rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-brand-300 transition-colors disabled:opacity-60"
    >
      <span aria-hidden>{state === 'sending' ? '⏳' : state === 'queued' ? '✓' : '🔄'}</span>
      {state === 'queued' ? t('Lancé')
        : state === 'error' ? t('Échec — réessayer')
          : t('Régénérer cet album')}
    </button>
    {state === 'queued' && at > 0 && (
      <span className="block w-64"><QuickBuildProgress shopifyOrderId={shopifyOrderId} album={albumIndex} since={at} compact /></span>
    )}
    </span>
  );
}
